/* Netpeak P22 (24.09.2026) — zamówienie indywidualne: krok 1 (typ nadwozia, grupy, liczba miejsc) i krok 2 (komplet pod
   rodzaj auta). Osobny plik ładowany tylko na produkcie typu „Individual” (sections/main-product.liquid), żeby
   pozostałe karty nie pobierały tego kodu; wcześniej ten sam blok siedział w evm-np.js. */
(function () {
  'use strict';

  /* Krok 1 (snippets/evm-np-indyw-auto.liquid): typ nadwozia w zwartej siatce z przełącznikiem grup i liczba miejsc
     zależna od typu (domyślna zaznaczona, przy jednej możliwej rząd schowany).
     Krok 2 (snippets/evm-np-set.liquid): lista kompletów z produktu-wzoru dla rodzaju auta (npFamily: typ + liczba miejsc).
     06.10.2026 (właściciel: listy z katalogu, nic wpisanego ręcznie): komplety, ich kolejność i ceny bierzemy z wzoru
     (/products/<wzór>.js), nazwę, podpis i schemat — jak na kartach zestawów (evm-cro-mobile.js, window.evmSetCard),
     na stronie EN nazwa ze słownika evm-en-config.js. Nowy komplet we wzorze pojawia się tu sam. Pięć wariantów „Zestaw”
     tego produktu (przedpłata 100 zł) zostaje schowanych: wybrany komplet zaznacza najbliższy z nich (kitBase), a dokładny
     komplet trafia na początek „Uwagi do zamówienia” jako „[Komplet: Zestaw: …]” w chwili wysłania — jedyne pole, które
     importer przenosi do sprawy w Bitrix. Nasłuch w fazie przechwytywania biegnie przed product-form.js, który czyta pola
     synchronicznie; po wysłaniu pole wraca do tekstu klienta (bez zdarzenia input, więc szkic w pamięci karty zostaje
     czysty). Prefiks z uwag (edycja z koszyka, szkic) wraca na wybór listy. Bez wzoru albo gdy wzór się nie wczyta —
     zwykłe kafelki produktu. Pytań „Dopasujmy komplet…” nie ma od 05.10 (właściciel). */
  var SET_PREFIX = /^\s*\[Komplet:([^\]]*)\]\s*/;
  var SEL_BODY = 'input[name="properties[Typ nadwozia]"]';
  var SEL_SEAT = 'input[name="properties[Liczba miejsc]"]';
  var NP_EN = /^en/i.test(document.documentElement.getAttribute('lang') || '');

  function npFamily(product) {
    var r = product.querySelector(SEL_BODY + ':checked');
    if (!r) return '';
    var body = r.getAttribute('data-evm-np-body') || '';
    var s = product.querySelector(SEL_SEAT + ':checked:not(:disabled)');
    var n = s ? parseInt(s.value, 10) || 0 : 0;
    switch (body) {
      case 'suv7': case 'mv7': return '7os';
      /* duży minivan: własny wzór (custom.indyw_wzor_mvxl); bez niego initSet bierze wzór 7-osobowy */
      case 'mvxl': return 'mvxl';
      case 'kombi': return n >= 6 ? '7os' : '5os';
      case 'coupe': case 'kabrio': return n === 2 ? '2os' : '5os';
      case 'roadster': return '2os';
      case 'vank': return 'van_maly';
      case 'vand': return n >= 5 ? 'brygada' : 'van';
      case 'bus': return 'bus';
      case 'pickup': return n && n <= 2 ? 'pickup1' : 'pickup';
      case 'tir': return 'tir';
      case 'ciagnik': return 'tractor';
      case 'kamper': return 'camper';
      case 'inny': return 'other';
      default: return body ? '5os' : '';
    }
  }


  var P = 'Przód', T = 'Tył', PT = 'Przód + tył', B = 'Mata do bagażnika', PTB = 'Przód + tył + bagażnik';
  /* Wartości zestawów na stronie EN są tłumaczone („Front”, „Front + rear”…), a kolejność opcji jest w każdym języku ta
     sama — wariant produktu szukamy po kolejności, gdy polska nazwa nie pasuje. */
  var SET_ORDER = [P, T, PT, B, PTB];
  /* Wariant tego produktu, który opisuje komplet z katalogu: „tył”, gdy komplet ma tylny rząd (tył, 2–3 rzędy, całe auto),
     „bagażnik”, gdy ma matę bagażnika. Komplet bez tylnego rzędu nigdy nie dostaje wariantu z „tył” — usługa sprawdzania
     kompletu w Bitrix zatrzymuje zamówienie z tylnym rzędem w aucie bez tylnych siedzeń; „przód + bagażnik” idzie jako
     „Przód”, a sam bagażnik / ładownia / paka jako „Mata do bagażnika” (dokładny komplet jest w uwagach). */
  function kitBase(name) {
    var v = String(name || '').toLowerCase();
    var trunk = /baga/.test(v);
    var rear = /(^|[^a-ząćęłńóśźż])ty[łl]($|[^a-ząćęłńóśźż])/.test(v) || /(^|\D)[2-9]\s*rz[ęe]d/.test(v) || /(^|\D)3\s*rz[ąa]d/.test(v) || /ca[łl]e\s+(auto|wn)/.test(v);
    var rearOnly = /^\s*ty[łl]\s*$/.test(v);
    var front = !rearOnly && (rear || /prz[oó]d|kierowc|kabin|tunel|(^|\D)1\s*rz[ąa]d/.test(v));
    if (rear && trunk) return PTB;
    if (rear) return front ? PT : T;
    if (trunk && !front) return B;
    return P;
  }
  /* Rodzaje auta bez tylnych siedzeń nigdy nie dostają wariantu z „tył” — ani z listy (także gdy ktoś wskaże wzór z tylnym
     rzędem), ani z kafelków, gdy wzór się nie wczytał. */
  var NO_REAR = { '2os': 1, pickup1: 1, van: 1, van_maly: 1, tir: 1, tractor: 1 };
  function famBase(fam, name) {
    var b = kitBase(name);
    return NO_REAR[fam] && (b === T || b === PT || b === PTB) ? P : b;
  }

  /* Wzory: produkt z metapola custom.indyw_wzory o danym custom.body_type (+ duży minivan z custom.indyw_wzor_mvxl);
     BT_FAM: body_type wzoru → rodzaje auta (npFamily). „Inny pojazd” (other) — jak auta 5-osobowe (właściciel 02.10). */
  var BT_FAM = { '5os': ['5os', 'other'], '2os': ['2os'], '7os': ['7os'], van_maly: ['van_maly'], pickup2kabina: ['pickup'],
    pickup: ['pickup1'], bus: ['bus'], bus_solid: ['bus'], van_duzy_separate_2_row: ['brygada'], van_duzy_separate: ['van'],
    tir: ['tir'], tractor: ['tractor'], camper: ['camper'], minivan: ['mvxl'] };
  /* rodzaj dywaników z pozycji zaznaczonego przycisku (0 = bez rantów, 1 = z rantami): na stronie EN wartości są
     przetłumaczone, a warianty wzoru czytamy po polsku */
  var RODZAJ = ['3D BEZ RANTÓW', '3D Z RANTAMI'];
  function vnorm(s) { return String(s || '').toLowerCase().replace(/\s*\/\s*/g, ' / ').replace(/\s+/g, ' ').trim(); }
  /* komplet z nazwy wariantu wzoru („3D Z RANTAMI / Przód” → „Przód”) */
  function kitOf(title) { return String(title || '').split(' / ').pop().trim(); }

  /* Ceny poglądowe z aktualnym rabatem, jak na stronie produktu (01.10, właściciel: „+актуальные скидки должны быть”).
     Źródło to samo, z którego liczy aplikacja Discount Mixer: aktywne kampanie produktowe w JSON-ie strony
     (script[data-dmixer-config="storefront"], czyta go też koszyk w cart-config-edit.js). Reguła jak w aplikacji
     (discount-runtime, wersja 1381): kampanie idą od najwyższego priorytetu i wygrywa pierwsza pasująca — okres sd/ed,
     tagi klienta ct/ec, filtry f i wyłączenia e (wariant vi, produkt i, typ p, producent v, tagi t, kolekcje c, cena l–h
     w zł; a = wystarczy jeden warunek). Rodzaj: P — procent (rabat w dół do grosza, limit m), F — kwota, N — cena
     końcowa. Bez JSON-a (blok aplikacji wyłączony) — potwierdzona tabela sklepu jak w koszyku: od 910 zł −30 %,
     290–900 zł −20 %. */
  var dmCfg = null;
  function dmConfig() {
    if (!dmCfg) {
      var el = document.querySelector('script[data-dmixer-config="storefront"]');
      try { dmCfg = el ? JSON.parse(el.textContent) : null; } catch (e) { dmCfg = null; }
    }
    return dmCfg;
  }
  function dmIn(csv, val) {
    var list = String(csv).split(',').map(function (x) { return x.trim(); });
    return [].concat(val).some(function (x) { return x != null && x !== '' && list.indexOf(String(x).trim()) !== -1; });
  }
  function dmMatch(c, pd, none) {
    if (!c) return none;
    var r = [];
    if (c.v) r.push(dmIn(c.v, pd.vendor));
    if (c.p) r.push(dmIn(c.p, pd.type));
    if (c.i) r.push(dmIn(c.i, pd.id));
    if (c.vi) r.push(dmIn(c.vi, pd.vid));
    if (c.t) r.push(dmIn(c.t, pd.tags));
    if (c.c) r.push(dmIn(c.c, pd.colls));
    if (c.l || c.h) r.push((c.l === undefined || pd.price >= Number(c.l)) && (c.h === undefined || pd.price <= Number(c.h)));
    return c.a ? r.some(Boolean) : r.every(Boolean);
  }
  function dmPeriod(c) {
    var now = Date.now();
    var s = c.sd ? new Date(c.sd).getTime() : 0;
    var e = c.ed ? new Date(c.ed).getTime() : 0;
    if (!s && !e) return true;
    return s && e ? now >= s && now <= e : s ? now >= s : false;
  }
  function dmTags(c, tags) {
    var ok = c.ct || [];
    var no = c.ec || [];
    if (no.some(function (t) { return tags.indexOf(t) !== -1; })) return false;
    return !ok.length || ok.some(function (t) { return tags.indexOf(t) !== -1; });
  }
  function salePrice(cents, pd) {
    var cfg = dmConfig();
    if (!cfg) {
      var pc = pd.price >= 910 ? 30 : pd.price >= 290 && pd.price <= 900 ? 20 : 0;
      return cents - Math.floor(cents * pc / 100);
    }
    var tags = (cfg.customer && cfg.customer.tags) || [];
    var list = (cfg.campaigns && cfg.campaigns.product) || [];
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      if (!c || !dmPeriod(c) || !dmTags(c, tags) || !dmMatch(c.f, pd, true) || dmMatch(c.e, pd, false)) continue;
      var d = Number(c.d) || 0;
      if (c.t === 'P') {
        var off = Math.floor(cents * d / 100 + 1e-6);
        if (c.m) off = Math.min(off, Math.round(c.m * 100));
        return Math.max(0, cents - off);
      }
      if (c.t === 'F') return Math.max(0, cents - Math.round(d * 100));
      if (Math.round(d * 100) < cents) return Math.round(d * 100);
    }
    return cents;
  }
  function zl(cents) {
    var s = (cents / 100).toFixed(2);
    return (/\.00$/.test(s) ? s.slice(0, -3) : s.replace('.', ',')) + '\u00a0zł';
  }


  function initBody(fs) {
    if (!fs || fs.dataset.evmNpReady) return;
    fs.dataset.evmNpReady = '1';
    var product = fs.closest('.product') || document;
    var catBox = fs.querySelector('[data-evm-np-cats]');
    var cats = Array.prototype.slice.call(fs.querySelectorAll('[data-evm-np-cat-btn]'));
    var seatsFs = product.querySelector('[data-evm-np-seats-fs]');
    var hint = seatsFs && seatsFs.querySelector('[data-evm-np-seats-hint]');
    var userCat = false;

    function picked() { return fs.querySelector(SEL_BODY + ':checked'); }
    function setCat(cat) {
      fs.setAttribute('data-evm-np-cat-on', cat);
      var p = picked();
      var pc = p ? p.getAttribute('data-evm-np-cat') : '';
      cats.forEach(function (b) {
        var c = b.getAttribute('data-evm-np-cat-btn');
        b.setAttribute('aria-pressed', c === cat ? 'true' : 'false');
        /* kropka na grupie, w której jest wybrany typ, gdy oglądamy inną */
        b.classList.toggle('has-pick', !!pc && c === pc && c !== cat);
      });
    }
    function syncSeats() {
      if (!seatsFs) return;
      var p = picked();
      var opts = p ? (p.getAttribute('data-evm-np-seats') || '').split(/\s+/).filter(Boolean) : [];
      var def = p ? (p.getAttribute('data-evm-np-seat') || '') : '';
      Array.prototype.forEach.call(seatsFs.querySelectorAll(SEL_SEAT), function (r) {
        var on = opts.indexOf(r.value) !== -1;
        r.disabled = !on;
        if (!on && r.checked) r.checked = false;
        var lab = seatsFs.querySelector('label[for="' + r.id + '"]');
        if (lab) lab.hidden = !on;
      });
      if (!seatsFs.querySelector(SEL_SEAT + ':checked') && def) {
        var d = seatsFs.querySelector(SEL_SEAT + '[value="' + def + '"]');
        if (d) {
          d.checked = true;
          d.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      seatsFs.hidden = opts.length < 2;
      if (hint) {
        var h = p ? (p.getAttribute('data-evm-np-seat-hint') || '') : '';
        hint.textContent = h;
        hint.hidden = !h || opts.length < 2;
      }
    }
    function sync() {
      var p = picked();
      if (!userCat) setCat(p ? p.getAttribute('data-evm-np-cat') : (fs.getAttribute('data-evm-np-cat-on') || 'os'));
      else setCat(fs.getAttribute('data-evm-np-cat-on') || 'os');
      syncSeats();
    }

    if (catBox) catBox.hidden = false;
    cats.forEach(function (b) {
      b.addEventListener('click', function () {
        userCat = true;
        setCat(b.getAttribute('data-evm-np-cat-btn'));
      });
    });
    fs.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'properties[Typ nadwozia]') {
        userCat = false;
        sync();
      }
    });
    /* Szkic z pamięci karty i edycja z koszyka zaznaczają typ bez zdarzenia change — dociągamy później. */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product__dropdown_button, .product__dropdown_title, .sticky_add_to_cart')) setTimeout(sync, 0);
    });
    [900, 2500].forEach(function (ms) { setTimeout(function () { if (!userCat) sync(); }, ms); });
    sync();
  }

  function initSet(box) {
    if (!box || box.dataset.evmNpReady) return;
    box.dataset.evmNpReady = '1';
    var product = box.closest('.product') || document;
    /* po nazwie, nie po id: formularz „Wyceń zestaw” na tej samej stronie ma własne pole z id „uwagi-do-zamowienia” */
    var UWAGI = 'textarea[name="properties[Uwagi do zamówienia]"]';
    var ta = product.querySelector(UWAGI) || document.querySelector(UWAGI);
    var setFs = product.querySelector('fieldset[data-name="mats_set"]');
    var listBox = box.querySelector('[data-evm-np-list]');
    var listItems = listBox && listBox.querySelector('[data-evm-np-list-items]');
    var refNote = box.querySelector('[data-evm-np-refnote]');
    var byRodzaj = box.querySelector('[data-evm-np-byrodzaj]');
    /* 13.10: rodzaje auta, których wzór w katalogu nie ma wyboru rodzaju (bus, TIR, vany, duży minivan…), nie pokazują bloku
       „Rodzaj dywaników” ani jego plakietki, a krok ma nagłówek bez „rodzaju” */
    var rodzajFs = product.querySelector('fieldset[data-name="mats_type"]');
    var stepWr = product.querySelector('.product__dropdown_wr[data-dropdown="mats_set_type"]');
    var stepTitle = stepWr && stepWr.querySelector('.product__dropdown_title');
    var stepSub = stepWr && stepWr.querySelector('.evm-step-sub');
    var altTitle = box.getAttribute('data-evm-np-t-title') || '';
    var altSub = box.getAttribute('data-evm-np-t-sub') || '';
    var rodzajShown = true;
    var userRodzaj = -1;
    var origTitle = null;
    var origSub = null;
    var quoteEl = box.querySelector('[data-evm-np-quote]');
    var quoteTxt = quoteEl ? quoteEl.textContent.trim() : '';
    if (!setFs || !listItems) return;
    /* wzory: rodzaj auta → { bt, handle, wz } */
    var REFS = {};
    try {
      JSON.parse((box.querySelector('[data-evm-np-refs]') || {}).textContent || '[]').forEach(function (r) {
        (r.fam ? [r.fam] : (BT_FAM[r.bt] || [])).forEach(function (f) { REFS[f] = r; });
      });
    } catch (e) { REFS = {}; }
    /* bez wzoru dużego minivana — jak auta 7-osobowe */
    if (!REFS.mvxl && REFS['7os']) REFS.mvxl = REFS['7os'];
    var listFam = '';
    var tries = 0;
    /* komplet z prefiksu uwag (edycja z koszyka, szkic) — zaznaczany przy najbliższej budowie listy */
    var pendingPick = null;
    /* wzór w trakcie wczytywania → lista czeka (bez kompletów i cen poprzedniego typu nadwozia); nieudane wczytanie nie
       zostaje zapamiętane na zawsze — przy następnej zmianie typu próbujemy znowu, a do tego czasu zwykłe kafelki */
    var refData = {};
    var pricedFam = '';
    function loadRef(r, retry) {
      var e = refData[r.handle];
      if (e && (e.ready || e.pending)) return e;
      if (e && e.failed && !retry) return e;
      refData[r.handle] = { pending: true };
      /* ścieżka bez prefiksu języka = polskie nazwy wariantów także na stronie EN */
      fetch('/products/' + encodeURIComponent(r.handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (j) { refData[r.handle] = { ready: true, variants: j.variants || [] }; })
        .catch(function () { refData[r.handle] = { failed: true }; })
        .then(function () { sync(); });
      return refData[r.handle];
    }
    function rodzajIdx() {
      var fsR = product.querySelector('fieldset[data-name="mats_type"]');
      if (!fsR) return -1;
      var rs = Array.prototype.slice.call(fsR.querySelectorAll('input[type="radio"]'));
      return rs.indexOf(fsR.querySelector('input[type="radio"]:checked'));
    }
    function titleNode() {
      if (!stepTitle) return null;
      for (var i = 0; i < stepTitle.childNodes.length; i++) {
        var n = stepTitle.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim()) return n;
      }
      return null;
    }
    /* Blok „Rodzaj dywaników”: pokazany tylko, gdy wzór ma wybór rodzaju. Bez wyboru: rodzaj wraca na pierwszą wartość
       („3D BEZ RANTÓW”, jak dotąd domyślnie), wybór klienta z innego typu nadwozia czeka i wraca po powrocie. */
    function setRodzaj(show) {
      if (!rodzajFs) return;
      var rs = Array.prototype.slice.call(rodzajFs.querySelectorAll('input[type="radio"]'));
      if (show === rodzajShown) {
        if (byRodzaj) byRodzaj.hidden = !show;
        /* ukryty rodzaj zostaje na pierwszej wartości także wtedy, gdy ktoś go ustawi później (szkic z pamięci karty
           zapisany, gdy wybór był jeszcze widoczny) */
        if (!show && rs.indexOf(rodzajFs.querySelector('input[type="radio"]:checked')) > 0 && rs[0]) check(rs[0]);
        return;
      }
      /* stan ustawiamy przed zmianą wartości: jej zdarzenie change nie może nadpisać zapamiętanego wyboru klienta */
      var cur = rs.indexOf(rodzajFs.querySelector('input[type="radio"]:checked'));
      rodzajShown = show;
      product.classList.toggle('evm-np-norodzaj', !show);
      if (!show) {
        if (cur > 0) userRodzaj = cur;
        if (rs[0]) check(rs[0]);
      } else if (userRodzaj > 0 && rs[userRodzaj]) {
        check(rs[userRodzaj]);
      }
      if (byRodzaj) byRodzaj.hidden = !show;
      var tn = titleNode();
      if (tn) {
        if (origTitle === null) origTitle = tn.nodeValue;
        if (!show && altTitle) tn.nodeValue = altTitle + ' ';
        else if (show) tn.nodeValue = origTitle;
      }
      if (stepSub) {
        if (origSub === null) origSub = stepSub.textContent;
        if (!show && altSub) stepSub.textContent = altSub;
        else if (show) stepSub.textContent = origSub;
      }
    }
    /* wariant wzoru dla kompletu: z wybranym rodzajem („3D Z RANTAMI / Przód”), a we wzorach bez rodzaju — sam komplet */
    function refVariant(d, kit) {
      var ri = rodzajIdx();
      var wantR = ri >= 0 ? vnorm(RODZAJ[ri] + ' / ' + kit) : '';
      var want = vnorm(kit);
      return d.variants.filter(function (x) { return vnorm(x.title) === wantR; })[0] ||
        d.variants.filter(function (x) { return vnorm(x.title) === want; })[0] || null;
    }
    /* cena po rabacie, przekreślona katalogowa i plakietka „-NN%” — ten sam układ co karty zestawów (evm-cro-mobile.js) */
    function paint(lab, pe, v, r) {
      var bd = lab.querySelector('.label_badge');
      if (!v) {
        pe.className = 'evm-set-price evm-np-price--q';
        pe.textContent = quoteTxt;
        if (bd) bd.remove();
        return;
      }
      var cents = Number(v.price);
      var now = salePrice(cents, { id: r.wz.id, vendor: r.wz.vendor, type: r.wz.type, tags: r.wz.tags || [], colls: r.wz.colls || [], vid: String(v.id), price: cents / 100 });
      pe.className = 'evm-set-price';
      var html = '<b>' + zl(now) + '</b>' + (now < cents ? '<s>' + zl(cents) + '</s>' : '');
      if (pe.innerHTML !== html) pe.innerHTML = html;
      var pct = now < cents ? Math.round((1 - now / cents) * 100) : 0;
      if (pct > 0) {
        if (!bd) { bd = document.createElement('span'); bd.className = 'label_badge'; lab.appendChild(bd); }
        bd.textContent = '-' + pct + '%';
      } else if (bd) {
        bd.remove();
      }
    }
    function check(inp) {
      if (inp && !inp.checked) {
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    function natSets() { return Array.prototype.slice.call(setFs.querySelectorAll('input[type="radio"]')); }
    function natSet(value) {
      var all = natSets();
      return all.filter(function (i) { return i.value === value; })[0] || all[SET_ORDER.indexOf(value)] || null;
    }
    function natValue(inp) {
      return SET_ORDER.indexOf(inp.value) !== -1 ? inp.value : (SET_ORDER[natSets().indexOf(inp)] || inp.value);
    }
    function labelOf(inp) {
      return setFs.querySelector('label[for="' + inp.id + '"]') || inp.closest('label');
    }
    /* oryginalne nazwy i obrazki kafelków — wracają, gdy rodzaj nie ma wzoru (zwykłe kafelki) */
    natSets().forEach(function (inp) {
      var im = (labelOf(inp) || document.createElement('i')).querySelector('img');
      inp.setAttribute('data-evm-np-orig-title', inp.getAttribute('data-title') || '');
      if (im) im.setAttribute('data-evm-np-orig-src', im.getAttribute('src') || '');
    });
    /* zwykłe kafelki (wzór się nie wczytał) u auta bez tylnych siedzeń: bez „Tył”, „Przód + tył”, „Przód + tył + bagażnik” */
    function offRear(fam) {
      var no = !!NO_REAR[fam];
      natSets().forEach(function (inp) {
        var v = natValue(inp);
        var off = no && (v === T || v === PT || v === PTB);
        var lab = labelOf(inp);
        inp.classList.toggle('evm-np-off', off);
        if (lab) lab.classList.toggle('evm-np-off', off);
      });
      var z = setFs.querySelector('input[type="radio"]:checked');
      if (no && z && z.classList.contains('evm-np-off')) check(natSet(P));
    }
    function restoreTiles() {
      natSets().forEach(function (inp) {
        inp.setAttribute('data-title', inp.getAttribute('data-evm-np-orig-title') || '');
        var im = (labelOf(inp) || document.createElement('i')).querySelector('img');
        if (im && im.hasAttribute('data-evm-np-orig-src')) im.setAttribute('src', im.getAttribute('data-evm-np-orig-src'));
      });
    }
    /* Wybór z listy zaznacza wariant bazowy produktu (100 zł). Podgląd konfiguratora (plakietka nad obrazkiem —
       product-config.js, wiersz podsumowania — evm-cro-mobile.js) bierze nazwę z data-title, a obrazek z kafelka
       zaznaczonego wariantu: kafelek bazowy (schowany) dostaje nazwę i schemat kompletu. Gdy wariant już był zaznaczony
       (np. Przód → Przód + bagażnik), zdarzenia zmiany nie ma — plakietkę odświeżamy sami. */
    function setBase(base, title, img) {
      var nat = natSet(base);
      if (!nat) return;
      if (title) nat.setAttribute('data-title', title);
      var lab = labelOf(nat);
      var im = lab && lab.querySelector('img');
      if (im && img && im.getAttribute('src') !== img) im.setAttribute('src', img);
      if (!nat.checked) check(nat);
      else if (typeof window.evmSyncConfigChips === 'function') window.evmSyncConfigChips();
    }

    /* Lista kompletów wzoru: komplety w kolejności katalogu, nazwa/podpis/schemat jak na kartach zestawów. */
    function buildList(fam, r, d) {
      var card = window.evmSetCard;
      /* „Najczęściej wybierany” (47 ze 106 zamówień od maja to „Przód + tył”, 24.09.2026) — kopia plakietki kart zestawów
         (evm-cro-mobile.js dodaje ją po swoim starcie) przy tym samym komplecie listy */
      var bestseller = setFs.querySelector('.evm-bestseller');
      /* najwyżej ~3 s czekania; potem lista zostaje taka, jaka jest (bez schematów albo bez plakietki) */
      tries += 1;
      listFam = (card && bestseller) || tries > 10 ? fam : '';
      listItems.textContent = '';
      var seen = {};
      d.variants.forEach(function (x) {
        var kit = kitOf(x.title);
        var k = vnorm(kit);
        if (!kit || seen[k]) return;
        seen[k] = 1;
        var c = card ? card(kit, r.bt) : { name: kit, sub: '', img: '' };
        var i = listItems.querySelectorAll('input').length;
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.name = 'evm_np_opt';
        inp.id = 'evm-np-opt-' + i;
        /* do uwag nazwa z katalogu (po polsku także na stronie EN — czyta produkcja) */
        inp.value = kit;
        inp.setAttribute('data-base', famBase(fam, kit));
        inp.setAttribute('data-title', c.name);
        inp.setAttribute('data-img', c.img || '');
        var lab = document.createElement('label');
        lab.className = 'evm-np-mv__opt';
        lab.htmlFor = inp.id;
        var img = document.createElement('img');
        img.alt = '';
        img.width = 54;
        img.height = 48;
        if (c.img) img.src = c.img;
        var txt = document.createElement('span');
        txt.className = 'evm-np-mv__txt';
        var nm = document.createElement('span');
        nm.className = 'evm-set-name';
        nm.textContent = c.name;
        var sb = document.createElement('span');
        sb.className = 'evm-set-sub';
        sb.textContent = c.sub || '';
        sb.hidden = !sb.textContent;
        txt.appendChild(nm);
        txt.appendChild(sb);
        var pe = document.createElement('span');
        pe.className = 'evm-set-price';
        lab.appendChild(img);
        lab.appendChild(txt);
        lab.appendChild(pe);
        if (bestseller && k === vnorm(PT)) {
          var bs = bestseller.cloneNode(true);
          bs.hidden = false;
          lab.insertBefore(bs, lab.firstChild);
        }
        listItems.appendChild(inp);
        listItems.appendChild(lab);
      });
      /* karty zestawów (evm-cro-mobile.js) startują później — gdy ich (albo plakietki) jeszcze nie ma, budujemy listę ponownie */
      if (!listFam) setTimeout(sync, 300);
    }
    /* zaznaczona pozycja: komplet z uwag (edycja, szkic), dotychczasowa, ten sam komplet co zaznaczony wariant produktu,
       pierwszy z tym wariantem (bez dywanika kierowcy), pierwszy bez dywanika kierowcy */
    function listPick() {
      var all = Array.prototype.slice.call(listItems.querySelectorAll('input[name="evm_np_opt"]'));
      var by = function (f) { return all.filter(f)[0] || null; };
      var driver = function (i) { return /kierowc/i.test(i.value); };
      var pick = null;
      if (pendingPick) {
        var want = vnorm(pendingPick);
        pendingPick = null;
        pick = by(function (i) { return vnorm(i.value) === want; });
      }
      pick = pick || by(function (i) { return i.checked; });
      var z = setFs.querySelector('input[type="radio"]:checked');
      var nat = z ? natValue(z) : '';
      return pick || by(function (i) { return vnorm(i.value) === vnorm(nat); }) ||
        by(function (i) { return i.getAttribute('data-base') === nat && !driver(i); }) ||
        by(function (i) { return !driver(i); }) || all[0] || null;
    }
    function applyList(fam, r, d) {
      if (listFam !== fam) buildList(fam, r, d);
      var pick = listPick();
      if (pick) {
        pick.checked = true;
        setBase(pick.getAttribute('data-base'), pick.getAttribute('data-title'), pick.getAttribute('data-img'));
      }
      Array.prototype.forEach.call(listItems.querySelectorAll('input[name="evm_np_opt"]'), function (inp) {
        var lab = listItems.querySelector('label[for="' + inp.id + '"]');
        if (lab) paint(lab, lab.querySelector('.evm-set-price'), refVariant(d, inp.value), r);
      });
      if (refNote) refNote.hidden = false;
      /* wzór bez wyboru rodzaju (bus, TIR, vany, duży minivan, ciągnik, kamper) — bloku „Rodzaj dywaników” nie ma */
      setRodzaj(d.variants.some(function (x) { return / \/ /.test(x.title); }));
    }

    /* Rodzaj auta z wzorem → lista kompletów zamiast kafelków; bez wzoru albo przy nieudanym wczytaniu — zwykłe kafelki. */
    function sync() {
      var fam = npFamily(product);
      var r = REFS[fam];
      var d = r ? loadRef(r, fam !== pricedFam) : null;
      pricedFam = fam;
      var on = !!r && !d.failed;
      listBox.hidden = !on;
      box.hidden = !on;
      setFs.classList.toggle('evm-np-mv-hide', on);
      /* także w czasie wczytywania wzoru i przy liście (kafelki wtedy schowane, lista nigdy nie daje „tył”) */
      offRear(NO_REAR[fam] ? fam : '');
      if (!on) { listFam = ''; restoreTiles(); if (!r || d.failed) setRodzaj(true); return; }
      if (d.pending) {
        if (listFam !== fam) { listItems.textContent = ''; listFam = ''; if (refNote) refNote.hidden = true; }
        return;
      }
      applyList(fam, r, d);
    }
    /* „[Komplet: Zestaw: Przód + bagażnik]” — wybór z widocznej listy */
    function compose() {
      var c = !listBox.hidden && listItems.querySelector('input:checked');
      return c ? '[Komplet: ' + listBox.getAttribute('data-uwagi') + ': ' + c.value + ']' : '';
    }
    /* Prefiks „[Komplet: …]” w uwagach (edycja z koszyka, szkic z pamięci karty) wraca na wybór listy i znika z pola.
       Pozycje listy powstają dopiero po wczytaniu wzoru — wybór czeka w pendingPick. Wpisy sprzed 06.10 („Zestaw (duży
       minivan)”) też; odpowiedzi dawnych pytań (przed 05.10) nie mają już przycisków — zostaje tylko zdjęcie prefiksu. */
    function restore() {
      if (!ta) return;
      var m = SET_PREFIX.exec(ta.value);
      if (!m) return;
      m[1].split(';').forEach(function (pair) {
        var i = pair.indexOf(':');
        if (i < 0) return;
        if (/^zestaw\b/i.test(pair.slice(0, i).trim())) {
          pendingPick = pair.slice(i + 1).trim();
          listFam = '';
        }
      });
      ta.value = ta.value.replace(SET_PREFIX, '');
    }

    product.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'properties[Typ nadwozia]' || t.name === 'properties[Liczba miejsc]' || (t.closest && t.closest('fieldset[data-name="mats_set"]'))) {
        setTimeout(sync, 0);
      } else if (t.closest && t.closest('[data-evm-np-set]')) {
        sync();
      } else if (t.closest && t.closest('fieldset[data-name="mats_type"]')) {
        /* rodzaj dywaników zmienia ceny wzoru (z rantami / bez) */
        if (rodzajShown) userRodzaj = rodzajIdx();
        setTimeout(sync, 0);
      }
    });
    /* Szkic konfiguracji przywracany z pamięci karty może zaznaczyć typ bez zdarzenia change — przeliczamy też
       przy przejściu między krokami. */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product__dropdown_button, .product__dropdown_title, .sticky_add_to_cart')) setTimeout(sync, 0);
    });
    /* szkic (evm-mat-cfg-persist.js) wpisuje uwagi już po starcie — prefiks kompletu odczytujemy po jego przywróceniu */
    document.addEventListener('evm-mat-cfg-restored', function () {
      restore();
      sync();
    });
    [700, 1600, 3200].forEach(function (ms) { setTimeout(sync, ms); });
    document.addEventListener('submit', function (e) {
      if (!ta || e.target !== ta.form) return;
      var own = ta.value.replace(SET_PREFIX, '');
      var extra = box.hidden ? '' : compose();
      if (!extra) return;
      ta.value = extra + (own.trim() ? ' ' + own : '');
      setTimeout(function () { ta.value = own; }, 0);
    }, true);
    restore();
    sync();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-evm-np-bt]'), initBody);
    Array.prototype.forEach.call(document.querySelectorAll('[data-evm-np-set]'), initSet);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
